import type { FilterComponentProps } from 'uikit';
import { TextField, TableFilterContainer } from 'uikit';

import { useCallback, useRef, useState } from 'react';

export const SearchStringFilter = ({ filterValue, onConfirm, onCancel }: FilterComponentProps) => {
    const ref = useRef<HTMLDivElement>(null);
    const [value, setValue] = useState<string>(filterValue as string);

    const handleOnChange = useCallback(({ value: newValue }: any) => {
        setValue(newValue);
    }, []);

    const handleConfirm = useCallback(() => onConfirm(value), [onConfirm, value]);
    const handleCancel = useCallback(() => onCancel(), [onCancel]);

    return (
        <TableFilterContainer onConfirm={handleConfirm} onCancel={handleCancel}>
            <TextField ref={ref} value={value} onChange={handleOnChange} type="text" style={{ width: '100%' }} />
        </TableFilterContainer>
    );
};

SearchStringFilter.displayName = 'SearchStringFilter';
